import React, { useState, useEffect, useContext, useCallback } from 'react';
import {
  Card,
  Container,
  Row,
  Col,
  CardHeader,
  CardBody,
  Button,
} from 'reactstrap';

import GoToTop from '../../components/GoToTop';
import Select from '../../components/Select';
import { AppContext } from '../../contexts/app';
import LayoutAdmin from '../../layouts/admin';
import api from '../../services/api';

export default function RelatorioAuditoria() {
  const [sessao, setSessao] = useState('');
  const [tema, setTema] = useState('');
  const [fileCsvUrl, setFileCsvUrl] = useState('');
  const [filePdfUrl, setFilePdfUrl] = useState('');
  const [sessoes, setSessoes] = useState([]);
  const [temas, setTemas] = useState([]);
  const { setLoading } = useContext(AppContext);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const { data = [] } = await api.get('/sessoes');
        setSessoes(
          data
            .filter((d) => !d.is_teste)
            .map((d) => ({
              value: d.id,
              label: `${d.id} - ${d.nome}`,
            })),
        );
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.log(error);
      }
    })();
  }, []);

  useEffect(() => {
    setTema('');
    setTemas([]);
    setFileCsvUrl('');
    setFilePdfUrl('');

    (async () => {
      try {
        if (sessao && sessao.value) {
          setLoading(true);
          const { data = [] } = await api.get(
            `/relatorioAuditoriaTemasBySessao/${sessao.value}`,
          );
          setTemas(
            (data || []).map((d) => ({
              value: d.id,
              label: `${d.id} - ${d.descricao}`,
            })),
          );
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        console.log(error);
      }
    })();
  }, [sessao && sessao.value]);

  const handleGerarRelatorio = useCallback(() => {
    (async () => {
      try {
        if (!tema || !tema.value) return;
        setLoading(true);
        setFileCsvUrl('');
        setFilePdfUrl('');
        const { data } = await api.get(`/relatorioAuditoriaByTema/${tema.value}`);
        setFileCsvUrl(data.file_csv_url || '');
        setFilePdfUrl(data.file_pdf_url || '');
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.log(error);
      }
    })();
  }, [tema && tema.value]);

  return (
    <LayoutAdmin>
      <Container>
        <GoToTop />
        <Row>
          <Col>
            <Card className="mt-5">
              <CardHeader>
                <h2>Relatório de Auditoria</h2>
              </CardHeader>
            </Card>

            <Row className="mt-3">
              <Col>
                <Card>
                  <CardHeader>Sessão</CardHeader>
                  <CardBody>
                    <Select
                      placeholder="Selecione uma Sessão"
                      value={sessao}
                      options={sessoes}
                      onChange={setSessao}
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>

            {sessao && sessao.value ? (
              <Row className="mt-3">
                <Col>
                  <Card>
                    <CardHeader>Tema auditável</CardHeader>
                    <CardBody>
                      <Select
                        placeholder={
                          temas.length
                            ? 'Selecione um Tema'
                            : 'Nenhum tema auditável finalizado nesta sessão'
                        }
                        value={tema}
                        options={temas}
                        onChange={(value) => {
                          setTema(value);
                          setFileCsvUrl('');
                          setFilePdfUrl('');
                        }}
                      />
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            ) : null}

            {tema && tema.value ? (
              <Row className="mt-3">
                <Col>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col xs={6}>
                          <Button
                            color="primary"
                            onClick={handleGerarRelatorio}
                            block
                            style={{
                              height: 75,
                              fontWeight: 'bold',
                              borderRadius: '0.75rem',
                            }}
                          >
                            Gerar Relatório
                          </Button>
                        </Col>
                        <Col xs={3}>
                          {fileCsvUrl ? (
                            <a
                              href={fileCsvUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <Button color="success" block style={{ height: 75 }}>
                                <i className="fa-solid fa-download mr-2" />
                                CSV
                              </Button>
                            </a>
                          ) : null}
                        </Col>
                        <Col xs={3}>
                          {filePdfUrl ? (
                            <a
                              href={filePdfUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <Button color="success" block style={{ height: 75 }}>
                                <i className="fa-solid fa-download mr-2" />
                                PDF
                              </Button>
                            </a>
                          ) : null}
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            ) : null}
          </Col>
        </Row>
      </Container>
    </LayoutAdmin>
  );
}
